import { lazy } from 'react';
import authRoles from '../../../auth/authRoles';

const Rates = lazy(() => import('./Rates'));
const AirFreight = lazy(() => import('./tabs/airFreight/airFreight/AirFreight'));
const SeaFreightFCL = lazy(() => import('./tabs/seaFreightFCL/details/SeaFreightFCL'));
const SeaFreightLCL = lazy(() => import('./tabs/seaFreightLCL/details/SeaFreightLCL'));
const FobCharge = lazy(() => import('./tabs/fobCharges/details/FobCharge'));
const ImportRates = lazy(() => import('./importRates/ImportRatesPage'));
const RateGroups = lazy(() => import('./rateGroups/RateGroupsPage'));
const CheckBuySellPage = lazy(() => import('./checkBuyVsSell/CheckBuySellPage'));
const RatesCalculationPage = lazy(() => import('./ratesCalculation/RatesCalculationPage'));

const RatesAppConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.admin,
   routes: [
      {
         path: '/operator/rates',
         element: <Rates />,
      },
      {
         path: '/operator/rates/airFreight/:airFreightId',
         element: <AirFreight />,
         children: [
            {
               path: 'version/:versionId',
               element: <AirFreight />,
            },
         ],
      },
      {
         path: '/operator/rates/seaFreightLCL/:seaFreightLCLId',
         element: <SeaFreightLCL />,
         children: [
            {
               path: 'version/:versionId',
               element: <SeaFreightLCL />,
            },
         ],
      },
      {
         path: '/operator/rates/seaFreightFCL/:seaFreightFCLId',
         element: <SeaFreightFCL />,
         children: [
            {
               path: 'version/:versionId',
               element: <SeaFreightFCL />,
            },
         ],
      },
      {
         path: '/operator/rates/fobcharge/:fobChargeId',
         element: <FobCharge />,
      },
      {
         path: '/operator/rates/importfiles',
         element: <ImportRates />,
      },
      {
         path: '/operator/rates/quarter',
         element: <RateGroups />,
      },
      {
         path: '/operator/rates/checkbuyandsell',
         element: <CheckBuySellPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         element: <RatesCalculationPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         element: <RatesCalculationPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         element: <RatesCalculationPage />,
      },
      {
         path: '/operator/rates/calculator/:mode',
         element: <RatesCalculationPage />,
      },
   ],
};

export default RatesAppConfig;
